import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import HtmlInNewWindow from '../utils/HtmlInNewWindow'; // Import the new component
import UserNameContext from '../UserNameContext';
import EnvContext from "../envContext";
import configData from '../sso_config.json';
import { useMsal } from "@azure/msal-react";
import { functionAppLoginRequest } from "../msalConfig";

function CreateDevice() {
  const [textBox1, setTextBox1] = useState('');
  const [textBox2, setTextBox2] = useState('');
  const [textBox3, setTextBox3] = useState('');
  const [textBox4, setTextBox4] = useState('');
  const [textBox5, setTextBox5] = useState('');
  const [dropdown, setDropdown] = useState('');
  const [otherTextBox, setOtherTextBox] = useState(''); // State for the "other" text box
  const [responseHtml, setResponseHtml] = useState(null); // State to store the response HTML
  const [isSubmitted, setIsSubmitted] = useState(false); // State to track if the form was submitte
  const [loading, setLoading] = useState(false); // State to track loading status
  const navigate = useNavigate();

  const { instance, accounts } = useMsal();

    // Pass username to Azure function using Json object
  const userName = useContext(UserNameContext);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@crestron\.com$/i;
    return emailRegex.test(email);
  };

  const env = useContext(EnvContext);
  console.log("ENV", env);
  const [textBox6, setTextBox6] = useState(env);

  // Predefined list for the dropdown
  const dropdownOptions = [  
    "AM-200",
    "AM-300",
    "AM-3000-WF",
    "AM-3000-WF-I",
    "AM-3100-WF",
    "AM-3100-WF-I",
    "AM-3200",
    "AM-3200-WF",
    "AM-3200-WF-I",
    "AMP-2800",
    "AMP-4600",
    "AMP-8075",
    "AMP-8150",
    "AMPI-8075",
    "AMPI-8150",
    "AudioMixer",
    "AV3",
    "AV4",
    "Avr",
    "BarcoConnectedDisplay",
    "BlurayPlayer",
    "CableBox",
    "CEN-ODT-C-POE",
    "ChristieDigitalConnectedDisplay",
    "CP3",
    "CP3N",
    "CP4",
    "CP4N",
    "DGE-100",
    "DIN-AP3",
    "DIN-AP3MEX",
    "DIN-AP4",
    "DM-DGE-200-C",
    "DM-MD16X16-CPU3",
    "DM-MD16X16-CPU3-RPS",
    "DM-MD32X32-CPU3",
    "DM-MD32X32-CPU3-RPS",
    "DM-MD8X8-CPU3",
    "DM-MD8X8-CPU3-RPS",
    "DM-NAX-AMP-X300",
    "DM-NVX-350",
    "DM-NVX-350C",
    "DM-NVX-351",
    "DM-NVX-351C",
    "DM-NVX-352",
    "DM-NVX-352C",
    "DM-NVX-360",
    "DM-NVX-360C",
    "DM-NVX-363",
    "DM-NVX-363C",
    "DM-NVX-D10",
    "DM-NVX-D20",
    "DM-NVX-D200",
    "DM-NVX-D30",
    "DM-NVX-D30C",
    "DM-NVX-D80-IOAV",
    "DM-NVX-E10",
    "DM-NVX-E20",
    "DM-NVX-E20-2G",
    "DM-NVX-E30",
    "DM-NVX-E30C",
    "DM-NVX-E760",
    "DM-NVX-E760C",
    "DMPS3-200-C",
    "DMPS3-300-C",
    "DMPS3-300-C-AEC",
    "DMPS3-4K-100-C",
    "DMPS3-4K-150-C",
    "DMPS3-4K-200-C",
    "DMPS3-4K-250-C",
    "DMPS3-4K-300-C",
    "DMPS3-4K-350-C",
    "DMPS3-4K-50",
    "DSP-1280",
    "DSP-1281",
    "DSP-1282",
    "DSP-1283",
    "DSP-860",
    "EpsonConnectedDisplay",
    "FT-TS600",
    "FT-TSC600",
    "HD-MD4X1-4KZ-E",
    "HD-MD4X2-4KZ-E",
    "HD-MD4X4-4KZ-E",
    "HD-MD8X4-4KZ-E",
    "HD-MD8X8-4KZ-E",
    "HD-PS401",
    "HD-PS402",
    "HD-PS621",
    "HD-PS622",
    "HD-RX-4K-210-C-E",
    "HD-RX-4K-210-C-E-POE",
    "HD-RX-4K-410-C-E",
    "HD-RX-4K-410-C-E-SW4",
    "HD-RX-4K-510-C-E",
    "HD-RX-4K-510-C-E-SW4",
    "LegrandConnectedPDU",
    "LGEConnectedDisplay",
    "MC4",
    "MERCURY",
    "MERCURY-TEAMS-AUDIO",
    "MERCURY-X",
    "MPC3-101",
    "MPC3-102",
    "MPC3-201",
    "MPC3-301",
    "MPC3-302",
    "OptomaConnectedDisplay",
    "PanasonicConnectedDisplay",
    "PC-350V-12",
    "PC-350V-18",
    "Ping",
    "PolycomVideoCodec",
    "PRO3",
    "PRO4",
    "RMC3",
    "RMC4",
    "SamsungConnectedDisplay",
    "SnmpMonitoring",
    "SonyConnectedDisplay",
    "TcpPortMonitoring",
    "TS-1070",
    "TS-1070-GV",
    "TS-1542",
    "TS-1542-C",
    "TS-770",
    "TS-770-GV",
    "TSCW-730",
    "TSS-10",
    "TSS-1070",
    "TSS-7",
    "TSS-770",
    "TSW-1060",
    "TSW-1060P",
    "TSW-1070",
    "TSW-1070-GV",
    "TSW-1070P",
    "TSW-1570",
    "TSW-1570-NC",
    "TSW-560",
    "TSW-560P",
    "TSW-570",
    "TSW-570P",
    "TSW-760",
    "TSW-770",
    "TSW-770-GV",
    "UC-2",
    "UC-2-I",
    "UC-ENGINE",
    "UC-ENGINE-SD",
    "UC-ENGINE-SD-Z",
    "UC-P10",
    "UC-P10-C",
    "UC-P10-C-I",
    "UC-P10-C-TAA",
    "UC-P10-I",
    "UC-P10-TAA",
    "UC-P10-TD",
    "UC-P10-TD-I",
    "UC-P250-T",
    "UC-P8",
    "UC-P8-C",
    "UC-P8-C-I",
    "UC-P8-C-TAA",
    "UC-P8-I",
    "UC-P8-TAA",
    "UC-P8-TD",
    "UC-P8-TD-I",
    "UC-PHONE-T",
    "UC-PHONE-T-PLUS",
    "VC-4",
    "VideoCodec",
    "VideoDisplay",
    "VideoServer",
    "XIO-CLOUD-GATEWAY",
    "ZUM-HUB4",
    "PhilipsConnectedDisplay", "other"];

  const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate input and check if all mandatory fields are filled
        if (!dropdown || !textBox1 || !textBox2 || !textBox3 || (dropdown === "other" && !otherTextBox)) {
          alert('Please enter mandatory fields, Device CID, Device MAC address, Device serial number, and Device model.');   
          console.log('Please enter mandatory fields.');
          return;
        }

        setLoading(true); // Set loading to true before making the API call
        setIsSubmitted(false); // Reset the submission state

        const data = {
          cid: textBox1.trim(),
          mac: textBox2.trim(),
          serialNumber: textBox3.trim(),
          accountNumber: textBox4.trim(),
      //   email: textBox5,
          env: textBox6.trim(),
       //   model: dropdown,
          model: dropdown === "other" ? otherTextBox : dropdown, // Include "other" field only if selected
          userName: userName
        };

        console.log("Json data",JSON.stringify(data))


        let endpointUrl = '';
        // API endpoint URL
        if(process.env.REACT_APP_RUN_ENV === 'local') {
            //endpointUrl = 'http://localhost:7071/api/create_device'; 
            endpointUrl = configData.LOCAL_API_URL + "create_device"; // Use the local API URL from the config file
        } else if (process.env.REACT_APP_RUN_ENV === 'qe') {
            //endpointUrl = 'https://xiosupporttool.azurewebsites.net/api/create_device';
            endpointUrl = configData.QE_API_URL + "create_device"; // Use the QE API URL from the config file
        } else {
          //endpointUrl = 'https://prd-use-atsgtool-func.azurewebsites.net/api/create_device';
          endpointUrl = configData.PROD_API_URL + "create_device"; // Use the production API URL from the config file
        }

        console.log("endpoint url",endpointUrl);
        try {
          // 1. Acquire token
          const account = accounts[0];
          const tokenResponse = await instance.acquireTokenSilent({
                  ...functionAppLoginRequest,
                  account: account
         });
          const token = tokenResponse.accessToken;
          const response = await fetch(endpointUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
          });

          if (response.ok) {
            const data = await response.text();
            setResponseHtml(data);
            setIsSubmitted(true); // Mark the form as submitted
            //alert('Device created successfully: ' + JSON.stringify(result));
          } else {
            alert('Failed to create device: ' + response.statusText);
          }
        } catch (error) {
            alert('Error: ' + error.message);
        } finally {
            setLoading(false); // Set loading to false after the API call is complete
        }
    };

      const handleClear = () => {
        setTextBox1('');
        setTextBox2('');
        setTextBox3('');
        setTextBox4('');
        setTextBox5('');
        setTextBox6('PRD');
        setDropdown('');
        setOtherTextBox('');
        setIsSubmitted(false); // Reset the submission state
      };

      const handleFieldChange = (setter) => (e) => {
        setter(e.target.value);
        setIsSubmitted(false); // Reset the submission state when any field changes
      };

      const goBack = () => {
        navigate(-1); // Navigate to the previous page
      };

      const goToHome = () => {
        navigate('/atsg/home'); // Navigate to the ATSG home page
      };

  return (
    <div className='menu-box shadow-xl shadow-cyan-500/30'>
      <div className='menu-title underline underline-offset-2'>
          <h2 >Create a Device</h2>
      </div>
      <div className='menu-content'>
      <form onSubmit={handleSubmit}>
        <div className='text-box-title'>
          <label>Device CID [Mandatory]</label>
          <input
            type="text"
            value={textBox1}
            title="Enter device CID."
            onChange={handleFieldChange(setTextBox1)}
            style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
          />
        </div>
        <div className='text-box-title'>
          <label>Device MAC address [Mandatory]</label>
          <input
            type="text"
            value={textBox2}
            title="Enter device MAC address."
            onChange={handleFieldChange(setTextBox2)}
            style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
          />
        </div>
        <div className='text-box-title'>
          <label>Dropdown:</label>
          <select
            value={dropdown}
            title="Select device model from the dropdown. If model is not listed select 'other' and enter the model in the text box."
            onChange={handleFieldChange(setDropdown)}
            style={{ width: '85%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
          >
            <option value="">-- Select --</option>
            {dropdownOptions.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        {/* Conditionally render the "other" text box */}
        {dropdown === "other" && (
          <div className='text-box-title'>
            <label>Device model [Mandatory]</label>
            <input
              type="text"
              title="Enter device model."
              value={otherTextBox}
              onChange={handleFieldChange(setOtherTextBox)}
              style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
            />
          </div>
        )}
        <div className='text-box-title'>
          <label>Device serial number [Mandatory]</label>
          <input
            type="text"
            value={textBox3}
            title="Enter device serial number."
            onChange={handleFieldChange(setTextBox3)}
            style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
          />
        </div>
        <div className='text-box-title'>
          <label>Account number [Optional]</label>
          <input
            type="text"
            value={textBox4}
            title="Enter account number."
            onChange={handleFieldChange(setTextBox4)}
            style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
          />
        </div>
        {/*
        <div style={{ width: '95%', marginBottom: '10px', fontSize: '18px', textAlign: 'left'  }}>
          <label>Notify Email Address</label>
          <input
            type="text"
            value={textBox5}
            title="Enter email address to receive notifications."
            onChange={handleFieldChange(setTextBox5)}
            style={{ width: '95%', padding: '8px', marginTop: '5px', marginBottom: '20x', fontSize: '15px' }}
          />
        </div>
        */}
        <div className='text-box-title'>
        <label>Environment</label>
        <input
            type="text"
            value={textBox6}
            title="Enter environment (e.g., PRD, HQE, etc.)."
            onChange={handleFieldChange(setTextBox6)}
            style={{ width: '80%', padding: '10px', marginTop: '5px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '15px' }}
            readOnly />
        </div>
        <div className='foot-box'>
          <button
            type="button"
            onClick={goBack} className='foot-button'
          >
            Back
          </button>
          <button className='foot-button'
          >
            Submit
          </button>
          <button
            type="button"
            onClick={handleClear} className='foot-button'
          >
            Clear
          </button>
          <button
            type="button"
            onClick={goToHome} className='foot-button'
          >
            Home
          </button>
        </div>
      </form>
        {/* Display loading message */}
        {loading && <p style={{ textAlign: 'center', marginTop: '20px', color: '#007CA0' , fontSize: '20px' }}>Loading...</p>}
        {/* Render the HtmlInNewWindow component when responseHtml is available */}
        {isSubmitted && responseHtml && <HtmlInNewWindow htmlContent={responseHtml} />} 
    </div>
  </div>
  );
}

export default CreateDevice;